<template>
  <div id="videoList" style="background-color: #F4F6F8;min-height: 905px">
    <div class="productBack">
      <div style="width: 1280px;text-align: left;display: inline-block">
        <div class="title">视频教程</div>
        <div class="subTitle">
          视频内容包含软件基础操作、多场景应用及专题讲解，并提供配套模型与说明文档。
        </div>
      </div>
    </div>
    <div style="width: 100%">
      <div class="topnav">
        <div style="width: 1280px;margin: 0 auto">
          <div class=" catLinks" ref="catLinks">
            <div v-for="(item,index) in categoryList" :key="index">
              <Dropdown v-if="item.hasThirdChildren===true" @on-click="choseCate($event,item,index)"
                        transfer transfer-class-name="dropdwonMeun">
                <span style="cursor: pointer">
                   {{ item.name }}
                </span>
                <DropdownMenu slot="list" >
                  <DropdownItem v-for="(i,idx) in item.children"  :name="i.id" >{{ i.name }}
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <span v-else @click="choseCate(item.id,item,index)" style="display: inline-block;cursor: pointer">
                 {{ item.name }}
              </span>

            </div>

          </div>
        </div>

      </div>
    </div>

    <div class="content">
      <div style="display: inline-block; width: 100%;">
        <div v-for="(i,idx) in videoCates">
          <div v-if="nowChoseCate!==-1" style="height: 16px;margin-top: 36px">
            <span style="display:inline-block; width: 3px;height: 16px;background: #0069E0;margin-right: 10px"></span>
            <div style="margin-bottom: 20px;font-size: 16px;color: #333333;display: inline-block;vertical-align: top;line-height: 16px">
              {{ i.name }}
            </div>
          </div>
          <div class="block" v-if="videoLists[idx].length!==0" v-for="(item,index) in videoLists[idx]">
            <div class="videoArea" @click="playVideo(item)">
              <div v-if="item.imgUri">
                <img :src="item.imgUri" alt="" style="width: 100%">
              </div>
              <div v-else>
                <video :src="item.uri" style="width: 100%"></video>
              </div>
            </div>
            <div class="textArea">
          <span class="cont" :title="item.description">
            {{ item.name }}
          </span>
              <span class="videoDown" @click="downloadVideo(item,index,idx)" style="float: right;cursor: pointer" title="下载视频">
              </span>
              <span class="fileDown" @click="openFileModal(item,index)" style="float: right;cursor: pointer;margin-right: 5px"
                    title="查看资料">
              </span>
              <span class="copyText" style="float: right;cursor: pointer;margin-right: 5px" title="复制地址" @click="getUrlText(item)"></span>
              <Progress class="progClass" v-if="item.showProg" :percent="item.prog"/>
            </div>
          </div>
        </div>
        <div v-if="nowChoseCate===-1" style="margin-top: 20px;text-align: center">
          <Page @on-change="changPage" :total="pageSet.total"  :page-size="pageSet.pageSize"/>
        </div>
      </div>


    </div>

<!--    <Modal-->
<!--      v-model="videoModal"-->
<!--      :title="tempVideo.name"-->
<!--      width="65%"-->
<!--      @on-ok="videoOk"-->
<!--      cancel-text=""-->
<!--      :mask-closable="false"-->
<!--    >-->
<!--      <video ref="video" :src="tempVideo.uri" style="width: 100%" controls autoplay></video>-->
<!--    </Modal>-->
    <Modal
      v-model="fileModal"
      title="资料列表"
      width="600"
      footer-hide
    >
      <Table border :columns="fileColumns" :data="fileList" style="margin: 10px">
        <template slot-scope="{ row, index }" slot="action">
          <Button type="primary" size="small" style="margin-right: 5px" @click="downLoadFile(row)">下载</Button>
        </template>
      </Table>
    </Modal>
  </div>
</template>

<script>
import axios from 'axios'
import {getCmsList, listCategory, searchFiles, listRelationFiles, earchFilesPage, searchFilesPage} from '../api/index'
import utils from '../lib/utils'
import downVideo from '../assets/img/downVideo.png'
import downVideoPop from '../assets/img/downVideoPop.png'

export default {
  name: "videoList",
  data() {
    return {
      categoryList: [],
      nowCate: 1,
      videoCates: [],

      videoLists: [],

      imgList: [],
      videoModal: false,
      tempVideo: {},

      fileModal: false,
      fileColumns: [
        {
          title: '名称',
          key: 'name'
        },
        {
          title: '操作',
          slot: 'action',
          width: 150,
          align: 'center'
        }
      ],
      fileList: [],
      videoSrc:downVideo,
      nowChoseCate:1,
      pageSet:{
        current:1,
        total:0,
        pageSize:12
      },
    }
  },

  watch: {
    videoModal: function (val) {
      if (val == false) {
        this.$refs.video.pause()
      }
    },
  },
  methods: {
    getIndex(idx){
      console.log(idx)
    },
    videoIn(){
      this.videoSrc=downVideoPop
    },
    VideoOut(){
      this.videoSrc=downVideo
    },
    openFileModal(item) {
      listRelationFiles({fileId: item.id}).then((res) => {
        if (!res.data.result.success) {
          this.$Message.error(res.data.result.info);
        } else {
          this.fileList = res.data.result.cmsFiles
          this.fileModal = true
        }
      }).catch((error) => {
        console.log(error);
      });

    },
    downLoadFile(item) {
      console.log(item)
      let uri = utils.handleHttps(item.uri)
      window.open(uri)
    },
    getCategoryList() {
      let data = {
        type: 'video',
      }
      listCategory(data).then((res) => {
        if (!res.data.result.success) {
          this.$Message.error(res.data.result.info);
        } else {
          console.log(res)
          this.categoryList = res.data.result.categorys
          this.categoryList.push({
            hasThirdChildren: false,
            showChildren: false,
            type: "video",
            id:-1,
            name:"最新视频"
          })
          this.categoryList.forEach((item) => {
            item.showChildren = false
          })
          this.nowCate = this.categoryList[0]
          this.choseCate(this.categoryList[0].id,this.categoryList[0],0)
        }
      }).catch((error) => {
        console.log(error);
      });
    },

    choseCate(id,item,idx) {
      console.log(this.nowCate)
      console.log(id)
      this.nowChoseCate=id
      if(id===-1){
        console.log(item)
        this.getNewVideo(idx)
      }
      else if(id===1){
        this.getVideo(0)
      }else{
        listCategory({
          type: 'video',
          pid: id
        }).then((res) => {
          console.log(res.data.result)
          if (!res.data.result.success) {
            this.$Message.error(res.data.result.info);
          } else {
            this.videoCates = []
            this.videoLists = []
            this.videoCates = res.data.result.categorys
            this.getVideos(idx)


          }
        }).catch((error) => {
          console.log(error);
        });

      }


    },

    getVideos(idx) {
      this.videoLists = []
      this.videoCates.forEach((item, index) => {
        searchFiles({
          type: 'video',
          categoryId: item.id
        }).then((res) => {
          if (!res.data.result.success) {
            this.$Message.error(res.data.result.info);
          } else {
            this.$set(this.videoLists, index, res.data.result.cmsFiles)
            if (this.videoLists[index].length !== 0) {
              this.videoLists[index].forEach((ids, ind) => {
                ids.uri = utils.handleHttps(ids.uri)
                ids.imgUri = utils.handleHttps(ids.imgUri)
                ids.prog = 0
              })
            }
          }
        }).catch((error) => {
          console.log(error);
        });
      })
      let spans = document.getElementsByClassName('catLinks')[0].querySelectorAll('span');
      spans.forEach((item) => {
        item.classList.remove("active")
      })
      spans[idx].classList.add("active")
      console.log(spans)
    },
    getVideo(idx) {
      searchFiles({
        type: 'video',
        categoryId: 1
      }).then((res) => {
        if (!res.data.result.success) {
          this.$Message.error(res.data.result.info);
        } else {
          this.videoCates = [this.nowCate]
          this.$set(this.videoLists, 0, res.data.result.cmsFiles)
          if (this.videoLists[0].length !== 0) {
            this.videoLists[0].forEach((item, index) => {
              item.uri = utils.handleHttps(item.uri)
              item.imgUri = utils.handleHttps(item.imgUri)
              item.prog = 0
              item.showProg = false
            })
          }
          let spans = document.getElementsByClassName('catLinks')[0].querySelectorAll('span');
          spans.forEach((item) => {
            item.classList.remove("active")
          })
          spans[idx].classList.add("active")
        }
      }).catch((error) => {
        console.log(error);
      });

    },
    getUrlText(item){
      const { href } = this.$router.resolve({
        path: '/playVideo',
        query: {
          vid: item.id,
        }
      });
      const fullUrl = window.location.origin + href;
      navigator.clipboard.writeText(fullUrl)
    },

    playVideo(item) {
      this.tempVideo = item
      console.log(item)
      // this.videoModal = true
      const { href } = this.$router.resolve({
        path: '/playVideo',
        query: {
          vid: item.id,
        }
      });
      const fullUrl = window.location.origin + href;
      console.log(fullUrl)
      window.open(fullUrl, '_blank');
    },
    videoOk() {
      this.$refs.video.pause()
      this.videoModal = false
    },

    downloadVideo(item, index, idx) {
      item.showProg = true
      let _this = this
      return new Promise((resolve, reject) => {
        axios(item.uri, {
          method: 'get',
          responseType: 'blob',
          onDownloadProgress: (progress) => {
            let progs = Math.round(progress.loaded / progress.total * 100)
            item.prog = progs
            item.uri = utils.handleHttps(item.uri)
            item.imgUri = utils.handleHttps(item.imgUri)
            _this.$set(_this.videoLists[idx], index, item)
          },
        })
          .then(res => {
            const blob = new Blob([res.data])
            const a = document.createElement('a')
            a.download = item.name + '.mp4'
            a.href = URL.createObjectURL(blob)
            a.click()
            URL.revokeObjectURL(a.href)
            a.remove()
            resolve()
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    changPage(num){
      this.pageSet.current = num;
      this.getNewVideo()
    },
    getNewVideo(idx){
      let data={
        type:'video',
        categoryId:-1,
        pageSize:this.pageSet.pageSize,
        pageNum:this.pageSet.current
      }
      searchFilesPage(data).then((res)=>{
        console.log(res)
        if(res.data.result.success){
          this.$set(this.videoLists, 0, res.data.result.cmsFiles)
          if (this.videoLists[0].length !== 0) {
            this.videoLists[0].forEach((item, index) => {
              item.uri = utils.handleHttps(item.uri)
              item.imgUri = utils.handleHttps(item.imgUri)
              item.prog = 0
              item.showProg = false
            })
          }
          this.pageSet.total=res.data.result.totalNum
        }
      })
      if(idx){
        let spans = document.getElementsByClassName('catLinks')[0].querySelectorAll('span');
        spans.forEach((item) => {
          item.classList.remove("active")
        })
        spans[idx].classList.add("active")
      }

    }

  },
  mounted() {

    window.scrollTo(0, 0)
    this.getCategoryList()



  }
}
</script>

<style scoped lang="scss">
.productBack {
  width: 100%;
  height: 280px;
  background: url("../../static/img/video/videoBack.png");
  text-align: center;

  .title {
    font-weight: 600;
    font-size: 32px;
    color: #FFFFFF;
    margin-top: 118px;
  }

  .subTitle {
    width: 60%;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 8px;
  }
}

.topnav {
  width: 100%;
  top: 0;
  height: 66px;
  /*background: #02298B;*/
  background: white;

  .brand {
    display: inline-block;

    img {
      width: 150px;
    }

    span {
      display: inline-block;
      color: white;
      font-size: 22px;
      vertical-align: bottom;
    }
  }

  .catLinks {
    display: flex;
    height: 65px;
    line-height: 65px;
    text-align: right;

    span {
      text-align: center;
      display: inline-block;
      height: 65px;
      padding: 0 20px;
      font-size: 16px;
      color: #333333;
    }

    span:hover {
      color: #185DE6;;
      border-bottom: 3px solid #185DE6;
    }
  }


}


.categories {
  display: inline-block;
  top: 105px;
  width: 200px;
  background-color: white;
  border-radius: 2px;
  padding: 25px;
  margin-right: 15px;
  height: 100%;

  .one {
    margin-bottom: 25px;
    font-size: 16px;
    color: #333333;
    font-weight: 800;
    cursor: pointer;
  }

  .two {
    margin-bottom: 25px;
    font-size: 14px;
    color: #666666;
    font-weight: 500;
    margin-left: 20px;
    cursor: pointer;
  }


}

.choseCate {
  color: #1175EB !important;
}

.content {
  display: flex;
  width: 1280px;
  margin: 0 auto;
  min-height: 830px;
  padding-bottom: 56px;

  .block {

    border-radius: 4px;
    position: relative;
    display: inline-block;
    width: 300px;
    border: 1px solid #EFEFEF;
    margin: 24px 10px 0 10px;
    .copyText{
      display: inline-block;
      width: 17px;
      height: 15px;
      background: url("../assets/img/copy.png");

    }
    .videoDown{
      display: inline-block;
      width: 17px;
      height: 15px;
      background: url("../assets/img/downVideo.png");

    }
    .fileDown{
      display: inline-block;
      width: 17px;
      height: 15px;
      background: url("../assets/img/files.png");

    }
    &:hover {
      box-shadow: 5px 5px 5px rgba(239, 239, 239, 1);
      color: #1175EB;
      .videoDown{
        background: url("../assets/img/downVideoPop.png");
      }
      .fileDown{
        background: url("../assets/img/filesPop.png");
      }
      .copyText{
        background: url("../assets/img/copyPop.png");
      }

    }


    .videoArea {
      /*font-size: 20px;*/
      /*line-height: 200px;*/
      overflow-y: hidden;
      height: 170px;
      width: 300px;
      cursor: pointer;
    }

    .textArea {
      height: 50px;
      background: #FFFFFF;
      border-radius: 0 0 4px 4px;
      padding: 15px;
      width: 300px;

      .cont {
        display: inline-block;
        width: 75%;
        /*width: 100%;*/
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .progClass {
        bottom: 0;
        left: 15px;
        position: absolute;
      }
    }

  }
}

@media (max-width: 1440px) {
  .content {
    width: 920px;
  }
  .categories {
    left: 5px;
  }
}
.active {
  color: #185DE6!important;
  border-bottom: 3px solid #185DE6!important;
}

</style>



// WEBPACK FOOTER //
// src/components/videoList.vue